import React, { useState } from "react";
import Swatch from "./Swatch";
import { PICS } from "./images";
import "./Palette.css";

const Swatches = ({ isMobile, addSwatch }) => {
  const [swatches, setSwatches] = useState(PICS);

  const handleAddSwatch = (swatch) => {
    const swatchIndex = swatches.findIndex((item) => item.id === swatch.id);
    swatches[swatchIndex] = swatch;
    addSwatch(swatch);
  };

  const pageDisplay = swatches.map((pic) => (
    <div className="createSwatches">
      <Swatch
        draggable
        key={pic.id}
        id={pic.id}
        url={pic.url}
        selected={pic.selected}
        isMobile={isMobile}
        handleAddSwatch={handleAddSwatch}
        inPalette={false}
      />
    </div>
  ));

  return <div className="pics">{pageDisplay}</div>;
};

export default Swatches;
